import { useContext } from "react";
import { recodeNow, secondarySearch, update } from "../../../components/indexDB/indexDBStora";
import { calculate_qty_depending_on_type } from "./utilites/convertorMeasures";
import { CurrentTime } from "../../current";
import { switchh } from "../../../context/switch";
import { validationInventory } from "../../validation/validationAddinInventory";
import { validationTransactionBatch } from "../../validation/validationTransactionBatch";
import { action } from "../../../context/action";
import { createTransaction } from './utilites/createTransaction';

export default function useCreationInventoryService () {
    const { setLoadingProcess } = useContext(switchh);
    const { setErrorMessage } = useContext(action);

    const commitBatchData = async (batch, inv, product) => {
        try {
            await Promise.all([
                recodeNow(batch, "batches"),
                update("warehouse", inv),
                update("products", product),
            ])
            return {success: true, message:""}
        }
        catch(error) {
            return {
                success: false,
                message: error.message
            }
        }
    }

    const createBatch = async (newBatch, newTransaction, index, product, inventory, meta, Reset) => {
        setLoadingProcess(true);
        // this is false related to validation the batchId
        const validationBatch = await validationInventory(newBatch, false);
        // validate transaction
        const validateTransaction = validationTransactionBatch(newTransaction);
        if (!validationBatch.success) {
            setErrorMessage(validationBatch.message);
            setLoadingProcess(false);
            return;
        }
        if(!validateTransaction.success) {
            setErrorMessage(validateTransaction.message);
            setLoadingProcess(false);
            return;
        }

        if(isNaN(index) || !product || !inventory || !meta) {
            setErrorMessage("missing data");
            setLoadingProcess(false);
            return;
        }
        try {
            
            setErrorMessage('');
            
            const generateName = newBatch.name?.length
                ? newBatch.name
                : `BATCH-${index}`;
    
            
            if(!product) {
                setErrorMessage("product is undefined!");
                setLoadingProcess(false);
                return;
            }
    
            const total = calculate_qty_depending_on_type(meta.type, newTransaction.qty, meta.boxes);
            if(total.total <= 0) {
                setErrorMessage("the quantity is not valid");
                setLoadingProcess(false);
                return;
            }
            const current =  CurrentTime(true, true);
            const id = newBatch.id;
            const RecordnewBatch = {
                ...newBatch,
                invId: inventory.id,
                meta: {
                    ...newBatch.meta,
                    createdAt: current,
                },
                productId: product.id,
                buyPrice: Math.round((Number(newBatch.buyPrice) || 0) * 100) / 100,
                name: generateName,
                currentQty: total.total,
                index: index
            };
    
            const RecordWithInvId = {
                ...product,
                inventoryId: inventory.id
            }
    
            
            const updatedInventory = {
                ...inventory,
                box: [...inventory.box, id]
            };
            
            const status = await commitBatchData(
                RecordnewBatch,
                updatedInventory,
                RecordWithInvId
            );

            if (status.success) {
                await createTransaction(
                    id,
                    current,
                    total,
                    newTransaction
                );
            }
            else {
                setErrorMessage(status.message);
                return;
            }
            
            if(Reset) {
                Reset();
            }

        } catch (error) {
            setErrorMessage(error.message);
        } finally {
            setLoadingProcess(false);
        }
    };

    const getAllBatches = async (id) => {
        if(!id) return [];
        const get_batches_product = await secondarySearch("batches", "productId", id);
        return get_batches_product || [];
    }

    return { createBatch, getAllBatches };
}